export default {
  // Ad platform types (for i18n)
  'adsPlatform.80004001': 'Google',
  'adsPlatform.80004002': 'Facebook',
  'adsPlatform.80004003': 'Twitter',
  'adsPlatform.80004004': 'TikTok',
  'adsPlatform.80004005': 'Adjust',
  'adsPlatform.80004006': 'SGTM',
  // Attribution event types (for i18n)
  'adsEvent.80005001': 'Register',
  'adsEvent.80005002': 'First Deposit',
  'adsEvent.80005003': 'Repeat Deposit',
  // Upload status types (for i18n)
  'adsPushStatus.80006001': 'Uploading',
  'adsPushStatus.80006002': 'Upload Failed',
  'adsPushStatus.80006003': 'Upload Success',
  // Page title
  'adsAccount.title': 'Ad Account List',

  // Search fields
  'adsAccount.platform': 'Attribution Platform',
  'adsAccount.name': 'Attribution Name',

  // Buttons
  'adsAccount.search': 'Search',
  'adsAccount.reset': 'Reset',
  'adsAccount.add': 'Add',
  'adsAccount.edit': 'Edit',
  'adsAccount.delete': 'Delete',
  'adsAccount.save': 'Save',
  'adsAccount.cancel': 'Cancel',

  // Table columns
  'adsAccount.serial': 'Serial',
  'adsAccount.adsId': 'Platform Account ID',
  'adsAccount.conversionId': 'Conversion ID',
  'adsAccount.gtmId': 'GTM-ID',
  'adsAccount.mccAccount': 'Associated MCC Account',
  'adsAccount.accessToken': 'Access Token',
  'adsAccount.clientId': 'OAuth Client ID',
  'adsAccount.registerEventPath': 'Registration Event ID',
  'adsAccount.firstRechargeEventPath': 'First Deposit Event ID',
  'adsAccount.rechargeEventPath': 'Recharge Event Path',
  'adsAccount.registerConversionLabel': 'Register Conversion Label (GTM)',
  'adsAccount.firstRechargeConversionLabel': 'First Recharge Conversion Label (GTM)',
  'adsAccount.repeatRechargeConversionLabel': 'Repeat Recharge Conversion Label (GTM)',
  'adsAccount.status': 'Status',
  'adsAccount.otherParams': 'Attribution Parameters',
  'adsAccount.action': 'Action',

  // Status
  'adsAccount.active': 'Active',
  'adsAccount.inactive': 'Inactive',

  // Form validation
  'adsAccount.platformRequired': 'Please select attribution platform',
  'adsAccount.nameRequired': 'Please enter attribution name',
  'adsAccount.adsIdRequired': 'Please enter platform account ID',
  'adsAccount.conversionIdRequired': 'Please enter conversion ID',
  'adsAccount.mccAccountRequired': 'Please select associated MCC account',
  'adsAccount.mccAccountPlaceholder': 'Please enter associated MCC account',
  'adsAccount.accessTokenRequired': 'Please enter access token',
  'adsAccount.clientIdRequired': 'Please enter OAuth Client ID',
  'adsAccount.registerEventPathRequired': 'Please enter registration event ID',
  'adsAccount.firstRechargeEventPathRequired': 'Please enter first deposit event ID',
  'adsAccount.repeatRechargeEventPathRequired': 'Please enter recharge event path',

  // Form placeholders
  'adsAccount.namePlaceholder': 'Please enter attribution name',
  'adsAccount.adsIdPlaceholder': 'Please enter platform account ID',
  'adsAccount.conversionIdPlaceholder': 'Please enter conversion ID',
  'adsAccount.registerEventPathPlaceholder': 'e.g.: /register/123',
  'adsAccount.firstRechargeEventPathPlaceholder': 'e.g.: /recharge/123',
  'adsAccount.registerConversionLabelPlaceholder': 'e.g.: 5txfCOaKzuwbEOPCia9A',
  'adsAccount.firstRechargeConversionLabelPlaceholder': 'e.g.: 5txfCOaKzuwbEOPCia9A',
  'adsAccount.repeatRechargeConversionLabelPlaceholder': 'e.g.: 5txfCOaKzuwbEOPCia9A',

  // Modal title
  'adsAccount.addAdsAccount': 'Add Ad Attribution Config',
  'adsAccount.editAdsAccount': 'Edit Ad Attribution Config',

  // Messages
  'adsAccount.addSuccess': 'Added successfully',
  'adsAccount.addFailed': 'Add failed',
  'adsAccount.editSuccess': 'Updated successfully',
  'adsAccount.editFailed': 'Update failed',
  'adsAccount.deleteSuccess': 'Deleted successfully',
  'adsAccount.deleteFailed': 'Delete failed',
  'adsAccount.confirmDelete': 'Are you sure to delete this record?',
  'adsAccount.validationError': 'Please fill in all required fields',
  'adsAccount.fetchDataFailed': 'Failed to fetch data',
  'adsAccount.fetchTypesFailed': 'Failed to fetch attribution platform types',
  'adsAccount.fetchMccAccountsFailed': 'Failed to fetch MCC accounts',
  'adsAccount.noData': 'No data',

  // Pagination
  'adsAccount.totalRecords': 'Total {total} records',
  'adsAccount.pagination': 'Page {current} of {page}, Total {total} records',
};
